import { render, staticRenderFns } from "./keyboardEmojiSelector.vue?vue&type=template&id=889389b2&"
import script from "./keyboardEmojiSelector.vue?vue&type=script&setup=true&lang=js&"
export * from "./keyboardEmojiSelector.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports